export const ORGANIZATION_EMPLOYEE_ROLES = 'OrganizationService/api/role/get-employee-roles'
export const USER_PRIVILEGES = 'OrganizationService/api/role/get-employee-role-privilege-mapping';

 export const ORGANIZATION_ALL_EMPLOYEE_ROLES = 'OrganizationService/api/role/get-all-employee-roles';

// REQUEST KIND MENU OPTIONS

export const REQUEST_KIND_MENU_OPTIONS = 'WorkflowService/api/workflow-definition/get-all-workflow-lookup';

// Employee configuration updates
export const ORGANIZATION_UPDATE_EMPLOYEE_PROPERTIES = 'OrganizationService/api/Employees/update-employee-property';

// Shortcuts (dashboard pins)
export const SHORTCUTS_LIST = 'OrganizationService/api/Shortcuts/list';
export const SHORTCUTS_TOGGLE = 'OrganizationService/api/Shortcuts/toggle';

export const NOTIFICATION_GET_MY = 'OrganizationService/api/notification/get-my-notification';
export const NOTIFICATION_READ = 'OrganizationService/api/notification/read';

export const NOTIFICATION_READ_ALL = 'OrganizationService/api/notification/read-all';

// Notification Types
export const NOTIFICATION_TYPE_DROPDOWN = 'OrganizationService/api/notification-type/get-all-drop-down';
export const NOTIFICATION_ASSIGN_TYPE_DROPDOWN = 'OrganizationService/api/notification-type/get-all-drop-down';


export const COMPANY_GET_ALL = 'OrganizationService/api/companies/get-all';
export const COMPANY_GET = 'OrganizationService/api/companies/get';
export const COMPANY_GET_TENANT_CONFIG = 'OrganizationService/api/companies/get-tenant-config';
export const COMPANY_CREATE = 'OrganizationService/api/companies/create';
export const COMPANY_UPDATE = 'OrganizationService/api/companies/update';
export const COMPANY_DELETE = 'OrganizationService/api/companies/delete';
export const COMPANY_BULK_DELETE = 'OrganizationService/api/companies/bulk-delete';
export const COMPANY_IMAGE_UPLOAD = 'OrganizationService/api/companies/image-upload';

export const MOBILE_GET_COMPANY_CONFIG = 'OrganizationService/api/mobile/get-company-config';
export const MOBILE_SAVE_COMPANY_CONFIG = 'OrganizationService/api/mobile/save-company-config';

export const MOBILE_GET_EMPLOYEE_CONFIG = 'OrganizationService/api/mobile/get-employee-config';
export const MOBILE_SAVE_EMPLOYEE_CONFIG = 'OrganizationService/api/mobile/save-employee-config';
